// クラシック版の第1世代の名前の文字と名前のダイアログ（段階 C の2 の 7f。2026-10-26 に画面ファイル gen1.js の setTextArea・btnMenuName から描き直した。動きは前と同じ）。
// setTextArea（NAME_ARC のメーカーだけ）: 名前の文字を作り直す。MODE_TEXT_ARC（ダイアログの「縁に沿って表示」）ならキャラの円の縁に沿って（textPath）、偽なら円の下に平らに。
//   台詞のメーカー（MODE_TEXT。blanc・rouge）は吹き出しの中（TEXT_SERIF で大きさ・位置）
// btnMenuName（第1世代。NAME_DIALOG_GEN2 の dressup は使わない＝menubuttons.ts の legacy の版）: ダイアログに「縁に沿って表示」のチェック（NAME_ARC_CHOICE）、
//   OK で MODE_TEXT_ARC を切りかえて setTextArea で名前を作り直す。見出しは NAME_DIALOG_LABEL（blanc）、チェックの初めの値を渡すかは NAME_DIALOG_ARC_ARG
// d3 は fx.d3any でそのまま（属性の並びも前と同じ）
import { chibi, common } from './engine.js';
import * as fx from './fx.js';
import { S } from './sel.js';
import * as jq from './jq.js';

type Engine = Record<string, any>;
const E = (): Engine => chibi() as unknown as Engine;
const C = (): Record<string, any> => common() as unknown as Record<string, any>;
const tt = (): Record<string, string> => (typeof _t !== 'undefined' && _t ? _t : {});

/** 名前の文字を作り直す（NAME_ARC のメーカー） */
export function setTextArea(aName?: string): void {
  const e = E();
  const serif = e.config('TEXT_SERIF', false);
  const fnsize = e.MODE_TEXT ? (serif ? 32 : 46) : 25;
  const name = aName != undefined ? aName : '';
  S
    .select('#' + e.SVG_TEXT + 'gname')
    .remove();
  S
    .select('#' + e.SVG_TEXT + 'name')
    .remove();
  S
    .select('#' + e.SVG_TEXT + 'nameBase')
    .remove();
  const clip = () => S.select('#' + e.SVG_CLIP);
  const gname = (): any =>
    clip()
      .append('g')
      .attr('width', clip().attr('width'))
      .attr('height', clip().attr('height'))
      .attr('id', e.SVG_TEXT + 'gname');
  const makeW = (): number => Number(S.select('#' + e.SVG_MAKE).attr('width'));
  if (e.MODE_TEXT) {
    // 台詞: 吹き出しの中
    gname()
      .append('text')
      .style('display', 'none')
      .attr('id', e.SVG_TEXT + 'name')
      .attr('x', makeW() * (e.isMobile ? 0.5 : (serif ? 0.48 : 0.5) * (e.SCALE_MAKE / 0.89)) - e.scMake.y(fnsize) * (e.isMobile ? 0.35 : 0.65))
      .attr('y', Number(clip().attr('height')) * (serif ? (e.isMobile ? 0.205 : 0.235 * (e.SCALE_MAKE / 1.1)) : e.isMobile ? 0.27 : 0.26 * (e.SCALE_MAKE / 0.89)) - e.scMake.y(fnsize * 1) / 2)
      .attr('text-anchor', 'middle')
      .attr('font-family', e.FONT_NAME)
      .attr('font-size', e.scMake.y(fnsize))
      .attr('fill', e.COLOR_NAME_WM)
      .attr('textdata', name)
      .text(name);
  } else if (e.MODE_TEXT_ARC) {
    // 円の縁に沿って（円弧のパス textmark は setCategory が作る）
    gname()
      .append('text')
      .attr('id', e.SVG_TEXT + 'nameBase')
      .attr('text-anchor', 'middle')
      .attr('font-family', e.FONT_NAME)
      .attr('font-size', e.scMake.y(fnsize))
      .attr('letter-spacing', 2)
      .attr('fill', e.COLOR_NAME_WM);
    S
      .select('#' + e.SVG_TEXT + 'nameBase')
      .append('textPath')
      .attr('id', e.SVG_TEXT + 'name')
      .style('display', 'none')
      .attr('startOffset', '50%')
      .attr('xlink:href', '#textmark')
      .attr('textdata', name)
      .text(name);
  } else {
    // 円の下に平らに
    gname()
      .append('text')
      .style('display', 'none')
      .attr('id', e.SVG_TEXT + 'name')
      .attr('x', makeW() * (e.isMobile ? 0.5 : 0.5 * (e.SCALE_MAKE / 0.94)) - e.scMake.y(fnsize) * (e.isMobile ? 0.35 : 0.65))
      .attr('y', Number(clip().attr('height')) * (e.isMobile ? 0.741 : 0.26 * (e.SCALE_MAKE / 0.33)) - e.scMake.y(fnsize * 1) / 2)
      .attr('text-anchor', 'middle')
      .attr('font-family', e.FONT_NAME)
      .attr('font-size', e.scMake.y(fnsize))
      .attr('fill', e.COLOR_NAME_WM)
      .attr('textdata', name)
      .text(name);
  }
  e.btnSubZoom.UPDATETEXT(0);
}

/** 第1世代の名前のボタン（「縁に沿って表示」のチェック付き） */
export function makeGen1NameButton(): Record<string, unknown> {
  const e = E();
  const dialogTexts = (): unknown[] => {
    const en = E();
    const cur = en.btnMenuName.GET();
    return [
      cur[0],
      en.config('NAME_DIALOG_LABEL', '') || (tt().name_label_genesis ? tt().name_label_genesis : 'Give your avatar a name.'),
      tt().name_placeholder_genesis ? tt().name_placeholder_genesis : 'Enter a name',
      en.config('NAME_ARC_CHOICE', true) ? '縁に沿って表示' : '', // profile などはチェックを出さない
      tt().name_public_note ? tt().name_public_note : '*The name will be public when saved.',
    ];
  };
  const name = (): Element | null => document.querySelector('#' + E().SVG_TEXT + 'name');
  return {
    ID: e.ATTR_EDITLISTBUTTON + 'Name',
    STATUS: 0,
    FILE: [e.PATH_IMG + 'switch/menu/bt_nameinput.svg'],
    CLICK: () => {
      E().btnMenuClose.CLICK();
      E().btnMenuName.EXEC();
    },
    // チェック「縁に沿って表示」の初めの値（MODE_TEXT_ARC）を渡すか（dash2・blanc・rouge は渡さない）
    EXEC: () => {
      const en = E();
      if (en.config('NAME_DIALOG_ARC_ARG', true)) C().openDialog('input', dialogTexts(), en.btnMenuName.OK, en.btnMenuName.CLOSE, en.MODE_TEXT_ARC);
      else C().openDialog('input', dialogTexts(), en.btnMenuName.OK, en.btnMenuName.CLOSE);
    },
    OK: () => {
      const en = E();
      const orgname = en.btnMenuName.GET();
      const el = name();
      const scol = orgname[0] == '' ? en.COLOR_NAME : el ? el.getAttribute('fill') : null;
      const nm = jq.val('#chaDivMyName').trim();
      en.MODE_TEXT_ARC = en.btnMenuName.GETCHECK();
      en.setTextArea(nm);
      en.btnMenuName.SET(nm, scol);
      en.saveChara(en.ATTR_AUTOSAVEKEY);
    },
    CLOSE: () => {},
    SETMODE: (anID: number) => {
      const en = E();
      const cur = en.btnMenuName.GET();
      en.isViewText = en.MODE_TEXT_VALID_MIN <= anID && anID <= en.MODE_TEXT_VALID_MAX;
      en.btnMenuName.SET(cur[0], cur[1]);
    },
    SET: (aValue: string | null, aColor?: string | null) => {
      const en = E();
      const tname = S.select('#' + en.SVG_TEXT + 'name');
      const valid = aValue != '';
      tname.attr('textdata', aValue);
      const ncolor = aColor != undefined ? aColor : en.COLOR_NAME;
      if (en.MODE_TEXT) {
        tname.attr('fill', valid ? ncolor : en.COLOR_NAME_WM);
        tname.text(valid ? aValue : en.isMobile ? (tt().name_input_tap ? tt().name_input_tap : '(Tap to enter)') : tt().name_input_click ? tt().name_input_click : '(Click to enter)');
        tname.style('display', en.isViewText ? 'block' : 'none');
      } else {
        tname.attr('fill', ncolor);
        tname.text(aValue);
        tname.style('display', valid ? 'block' : 'none');
      }
    },
    GET: (aQuat?: boolean) => {
      const sel = S.select('#' + E().SVG_TEXT + 'name');
      let nm = sel.attr('textdata');
      if (aQuat) nm = encodeURIComponent(nm);
      return [nm, sel.attr('fill')];
    },
    GETCHECK: () => jq.prop('#chaDivNameArc', 'checked'),
  };
}
